import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { getFullName } from "utils";

function AlternateDirectorsForm(props) {
  const { form } = props;
  let setFieldValue = null;
  if (props.setFieldValue) {
    setFieldValue = props.setFieldValue;
  } else if (form.setFieldValue) {
    setFieldValue = form.setFieldValue;
  }
  // Correct destructuring
  const [selectedDirectors, setSelectedDirectors] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const companyDashboardSlice = useSelector(
    (state) => state.companyDashboardSlice
  );
  const { companyOfficials } = companyDashboardSlice;

  const filterDirectors = companyOfficials.items.filter(
    (item) =>
      item.designation === "Director" ||
      item.designation === "Director Shareholder"
  );

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleDirectorClick = (director) => {
    setSelectedDirectors((prev) => {
      const isAlreadySelected = prev.some((d) => d._id === director._id);
      const updatedDirectors = isAlreadySelected
        ? prev.filter((d) => d._id !== director._id)
        : [...prev, director];
      setFieldValue("directorsList", updatedDirectors);
      return updatedDirectors;
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <form className="mt-4">
      <div className="px-4 py-6 mt-2 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md">
        <div className="col-span-6 sm:col-span-3">
          <label
            htmlFor="designation"
            className="block text-sm font-medium text-gray-700"
          >
            Select below at least one Appointer
          </label>
          <div className="relative mt-2" ref={dropdownRef}>
            <button
              type="button"
              onClick={toggleDropdown}
              className="block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-left"
            >
              {selectedDirectors.length > 0
                ? selectedDirectors.map((d) => d.names.firstName).join(", ")
                : "Select Directors"}
            </button>

            {isDropdownOpen && (
              <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                <ul className="max-h-40 overflow-y-auto">
                  {filterDirectors.map((director) => (
                    <li
                      key={director._id}
                      onClick={() => handleDirectorClick(director)}
                      className={`cursor-pointer px-4 py-2 text-sm ${
                        selectedDirectors.some((d) => d._id === director._id)
                          ? "bg-indigo-500 text-white"
                          : "hover:bg-gray-100"
                      }`}
                    >
                      {director.idType === "Local Company"
                        ? director.names.companyName
                        : getFullName(director.names)}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        {selectedDirectors.length > 0 && (
          <div className="mt-4">
            <h4 className="text-sm font-semibold text-gray-700">
              {selectedDirectors.length === 1
                ? "Appointer's Full Name"
                : "Appointers' Full Name"}
            </h4>
            <ul className="list-disc list-inside mt-2 text-gray-600">
              {selectedDirectors.map((director) => (
                <li key={director._id}>
                  {director.names.firstName} {director.names.lastName}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </form>
  );
}

export default AlternateDirectorsForm;
